import { BASE_API_URL } from "../../config/Api";
import { ADD_CLIENT, ADD_CUSTOMER_DATA, ADD_DESIGNATION_DATA, ADD_HOLIDAY_DATA, ADD_NOTICE, ADD_PROJECT_DATA, ADD_TEAM_MEMBER, ASSIGN_REPORT, CLIENT_DATA, CLIENT_DETAILS, CLOSE_REPORT, CUSTOMER_LIST, EMAIL_DATA, HOLIDAY_LIST, INSERT_REPORT_DATA, NOTICE_DATA, NOTICE_DETAILS, NOTIFICATION_LIST, NOTIFICATION_UPDATE, PENDING_ISSUE_LIST, PROJECT_ACCESS_LIST, RELEASE_TEAM_MEMBER, REPORT_CLOSED_LIST, REPORT_ISSUE_LIST } from "./ActionType";

export const addClientDetails = (formData, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/addClientDetails`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(formData),
        })
        const resData = await res.json();
        if (res.ok) {
            dispatch({ type: ADD_CLIENT, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
        console.error("Error:", error);
    }
}

export const fetchClientDetails = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/fetchClientDetails`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: CLIENT_DETAILS, payload: resData })
    } catch (error) {

    }
}

export const fetchClientData = (clientMasterId, token) => async (dispatch) => {
    try {
        const res = await fetch(
            `${BASE_API_URL}/fetchClientDataById?clientMasterId=${clientMasterId}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const resData = await res.json();
        dispatch({ type: CLIENT_DATA, payload: resData });
    } catch (error) { }
};

export const fetchNoticeData = (noticeId, token) => async (dispatch) => {
    try {
        const res = await fetch(
            `${BASE_API_URL}/fetchNoticeDataById?noticeId=${noticeId}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const resData = await res.json();
        dispatch({ type: NOTICE_DATA, payload: resData });
    } catch (error) { }
};

export const addNoticeDetails = (formData, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/addNoticeDetails`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(formData),
        })
        const resData = await res.json();
        if (res.ok) {
            dispatch({ type: ADD_NOTICE, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
        console.error("Error:", error);
    }
}

export const fetchNoticeDetails = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/fetchNoticeDetails`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: NOTICE_DETAILS, payload: resData })
    } catch (error) {

    }
}

export const addProjectData = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/add-project-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_PROJECT_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in addProjectData:", error);
    }
}

export const addCustomerData = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/add-customer-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_CUSTOMER_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in addCustomerData:", error);
    }
}

export const getCustomerList = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/get-customer-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: CUSTOMER_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching customer list:", error);
    }
};

export const addDesignation = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/add-designation-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_DESIGNATION_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in addCustomerData:", error);
    }
}

export const getEmailData = (token, fromDate, toDate) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/email-data?fromDate=${fromDate}&toDate=${toDate}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: EMAIL_DATA, payload: resData })
    } catch (error) {
        console.error("Error in fetching email data:", error);
    }
};

export const insertReportIssue = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/insert-report-issue`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: INSERT_REPORT_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in insertReportIssue:", error);
    }
}

export const getReportList = (fromDate, toDate, loginId, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/get-report-list?fromDate=${fromDate}&toDate=${toDate}&loginId=${loginId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: REPORT_ISSUE_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching report issue list:", error);
    }
};

export const assignReport = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/assign-report`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ASSIGN_REPORT, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in assignReport:", error);
    }
}

export const closeReport = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/close-report`, {
            method: "PUT", headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
             body: JSON.stringify(data),
        }
        );

        const resData = await res.json();


        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: CLOSE_REPORT, payload: resData });
            return { success: true, data: resData };
        } else {
            return {
                success: false, error: resData?.statusDesc || `HTTP error: ${res.status}`,
            };
        }
    } catch (error) {
        console.error("Error in closeReport:", error);
        return {
            success: false, error: error.message || "Network error",
        };
    }
};

export const getHolidayList = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/holidayList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: HOLIDAY_LIST, payload: resData });
  } catch (error) {}
};

export const holidayListupdate = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/holidayListupdate`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_HOLIDAY_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in holidayListupdate:", error);
    }
}

export const projectAccessListByProjectId = (projectMasterId,token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/project-access-list?projectMasterId=${projectMasterId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: PROJECT_ACCESS_LIST, payload: resData });
  } catch (error) {}
};

export const addTeamMember = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/add-team-member`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_TEAM_MEMBER, payload: resData });
            return resData;
        } else {
            return {success: false, error: resData.statusDesc || "An unknown error occurred", };
        }
    } catch (error) {
        console.error("Error occurred in addProjectTeamMember:", error);
    }
}

export const releaseTeamMember = (projectAccessId, loginId, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/release-team-member?projectAccessId=${projectAccessId}&loginId=${loginId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: RELEASE_TEAM_MEMBER, payload: resData });
            return resData;
        } else {
            return {success: false, error: resData.statusDesc || "An unknown error occurred", };
        }
    } catch (error) {
        console.error("Error occurred in releaseTeamMember:", error);
    }
}

export const getPendingReportList = (projectCode, customerName, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/get-pending-report-list?projectCode=${projectCode}&customerName=${customerName}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: PENDING_ISSUE_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching penidng report issue list:", error);
    }
};

export const getClosedReportList = (fromDate, toDate, loginId, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/get-closed-report-list?fromDate=${fromDate}&toDate=${toDate}&loginId=${loginId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: REPORT_CLOSED_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching report closed list:", error);
    }
};

export const getNotification = (loginId, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/get-notification?loginId=${loginId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: NOTIFICATION_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching notification list:", error);
    }
};

export const updateNotification = (dto, loginId, token) => async (dispatch) => {
    try {
        const res = await fetch(
            `${BASE_API_URL}/update-notification?loginId=${loginId}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(dto)   
            }
        );

        const resData = await res.json();
        dispatch({ type: NOTIFICATION_UPDATE,payload: resData });

    } catch (error) {
        console.error("Error in updating notification :", error);
    }
};
export const clearNotification = (loginId, token) => async (dispatch) => {
    try {
        const res = await fetch(
            `${BASE_API_URL}/clear-notification?loginId=${loginId}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                
            }
        );

        const resData = await res.json();
        dispatch({ type: NOTIFICATION_UPDATE,payload: resData });

    } catch (error) {
        console.error("Error in updating notification :", error);
    }
};
